import { Popover, Space, Table, Tooltip } from "antd";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Typography from "Components/CommonComponents/Typography";
import FeedbackViewModal from "Pages/Faculties/FeedbackViewModal";
import { capitalizeWords } from "utilFunctions/helperFunctions/HelperFunction";
import InfoIcon from "Assets/Icons/InfoIcon";
interface FacultiesRegionsTableIF {
  data: any[];
  pagination: any;
  setPagination: any;
  mode: string;
  extraInformation?: any;
}
const returnMarkedvaluue = (
  message: string,
  markedLectureCount: any,
  unmarkedLectureCount: any
) => {
  const markedsvalue: any = [];
  markedsvalue.push({
    label: "Marked " + message + ":",
    value: markedLectureCount,
  });
  markedsvalue.push({
    label: "Total " + message + ":",
    value: markedLectureCount + unmarkedLectureCount,
  });
  return markedsvalue;
};
const returnPercentage = (
  markedLectureCount: any,
  unmarkedLectureCount: any
) => {
  const markedLectures = markedLectureCount;
  const unmarkedLectures = unmarkedLectureCount;
  let percentage = 0;
  if (markedLectures != 0 || unmarkedLectures != 0) {
    percentage =
      (Number(markedLectures) /
        (Number(markedLectures) + Number(unmarkedLectures))) *
      100;
    percentage = parseFloat(percentage.toFixed(0));
  }
  return percentage;
};
const returnFollowUpCount = (followUpCount: any, ptmCount: any) => {
  const markedsvalue: any = [];
  markedsvalue.push({
    label: "Follow-ups :",
    value: followUpCount ? followUpCount : 0,
  });
  markedsvalue.push({
    label: "PTMs :",
    value: ptmCount ? ptmCount : 0,
  });
  return markedsvalue;
};
const FacultiesRegionsTable = ({
  data,
  pagination,
  setPagination,
  mode,
  extraInformation,
}: FacultiesRegionsTableIF) => {
  const navigate = useNavigate();
  const [selectedRowItem, setSelectedRowItem] = useState({});
  const [isLectureViewModal, setIsLectureViewModal] = useState<any>(false);
  const routeToRegionStateBranches = (item: any) => {
    if (mode === "Region") {
      navigate("/admin/faculties/states/" + item.branchOrStateOrRegionId, {
        replace: false,
        state: {
          selectedRegion: item,
        },
      });
    } else if (mode === "State") {
      navigate("/admin/faculties/branches/" + item.branchOrStateOrRegionId, {
        replace: false,
        state: {
          selectedState: item,
          selectedRegion: extraInformation.selectedRegion,
        },
      });
    } else if (mode === "Branch") {
      navigate("/admin/faculties/branch/" + item.branchOrStateOrRegionId, {
        replace: false,
        state: {
          selectedBatch: item.branchOrStateOrRegionId,
          selectedRegion: extraInformation.selectedRegion,
          selectedState: extraInformation.selectedState,
          selectedStream: extraInformation.streamId,
        },
      });
    } else if (mode === "Faculty") {
      navigate("/admin/faculties/" + item.id, {
        replace: false,
        state: {
          faculty: item,
          selectedBatch: extraInformation && extraInformation?.selectedBatch,
          selectedRegion: extraInformation && extraInformation?.selectedRegion,
          selectedState: extraInformation.selectedState,
          selectedDefaultTab: "1",
        },
      });
    }
  };
  const handleTodayUnmarkedAttendance = (item: any) => {
    navigate("/admin/faculties/" + item.id, {
      replace: false,
      state: {
        faculty: { ...item, facultyId: item.employeeId },
        selectedBatch: extraInformation && extraInformation?.selectedBatch,
        selectedRegion: extraInformation && extraInformation?.regionId,
        selectedDefaultTab: "3",
      },
    });
  };
  const handleOverAllratingmodal = (item: any) => {
    setSelectedRowItem((prevRowItem) => ({ ...prevRowItem, ...item }));
    setIsLectureViewModal(true);
  };
  const columns: any = [
    {
      title: mode + " Name",
      dataIndex: "branchOrStateOrRegionName",
      fixed: "left",
      access: ["Branch", "State", "Region", "Faculty"],
      render: (_: any, record: any) => {
        return (
          <span
            className="tableIdStyle"
            onClick={() => routeToRegionStateBranches(record)}
          >
            {["Faculty"].includes(mode)
              ? record.name &&
                capitalizeWords(record.name) + " | " + record?.employeeId
              : record?.branchOrStateOrRegionName &&
                capitalizeWords(record.branchOrStateOrRegionName)}
          </span>
        );
      },
    },
    {
      title: "Total Faculties",
      dataIndex: "totalFacultiesCount",
      sorter: true,
      access: ["Branch", "State", "Region"],
      render: (_: any, record: any) => {
        return <span>{record?.totalFacultiesCount}</span>;
      },
    },
    {
      title: "Marked Lectures %",
      dataIndex: "markedLectureCount",
      access: ["Branch", "Region", "State", "Faculty"],
      render: (_: any, item: any) => {
        const dataMarkedLecture = returnMarkedvaluue(
          "Lectures",
          item.markedLectureCount,
          item.unmarkedLectureCount
        );
        const percentage = returnPercentage(
          item.markedLectureCount,
          item.unmarkedLectureCount
        );
        return (
          <div>
            {mode == "Faculty" &&
            item.markedLectureCount == 0 &&
            item.unmarkedLectureCount == 0 ? (
              <Space>
                <Tooltip title="Syllabus status is not visible to ALC Coordinators. Only ALC Faculty can mark syllabus for ALC classes.">
                  <span>{"NA"}</span>
                  <InfoIcon id={"Tooltip-markedLecture-NA"}></InfoIcon>
                </Tooltip>
              </Space>
            ) : dataMarkedLecture ? (
              <Popover
                placement="rightTop"
                content={() => (
                  <>
                    {dataMarkedLecture.map((ele: any, index: number) => (
                      <div
                        key={index}
                        className="markedLectureCountStyle d-flex flex-column justify-content-between mb-2"
                      >
                        <div className="d-flex flex-row w-100">
                          <Typography variant="h6" color="black">
                            {ele.label} &nbsp;
                          </Typography>
                          <Typography variant="h6" color="black">
                            {ele.value}
                          </Typography>
                        </div>
                      </div>
                    ))}
                    {/* <div className="d-flex flex-row w-100 text-muted">
                      Data excludes the ALC classes
                    </div> */}
                  </>
                )}
                title={""}
              >
                <div
                  className={
                    percentage || percentage == 0 ? "tableIdStyle" : ""
                  }
                >
                  {percentage ? percentage + "%" : percentage == 0 ? "0%" : "-"}
                </div>
              </Popover>
            ) : (
              "-"
            )}
          </div>
        );
      },
    },
    {
      title: "Unmarked Lectures",
      dataIndex: "unmarkedLectureCount",
      sorter: true,
      access: ["Branch", "Region", "State", "Faculty"],
      render: (_: any, record: any) => {
        return <span>{record?.unmarkedLectureCount}</span>;
      },
    },
    {
      title: "Marked Attendance %",
      dataIndex: "markedAttendancePercent",
      access: ["Branch", "Region", "State", "Faculty"],
      sorter: ["Branch", "Region"].includes(mode) ? false : true,
      render: (_: any, item: any) => {
        const dataMarkedLecture = returnMarkedvaluue(
          "Attendance",
          item.markedAttdCount,
          item.unmarkedAttdCount
        );
        const percentage = returnPercentage(
          item.markedAttdCount,
          item.unmarkedAttdCount
        );
        return (
          <div>
            {mode == "Faculty" &&
            item.markedAttdCount == 0 &&
            item.unmarkedAttdCount == 0 ? (
              <Space>
                <Tooltip title="Attendance is not visible to ALC faculty. Only Coordinators at the center can take and access attendance.">
                  <span>{"NA"}</span>
                  <InfoIcon id={"Tooltip-markedAttendance-NA"}></InfoIcon>
                </Tooltip>
              </Space>
            ) : mode != "Faculty" &&
              item.markedAttdCount == 0 &&
              item.unmarkedAttdCount == 0 ? (
              <Space>
                <Tooltip title="Attendance data is not present.">
                  <span>{"NA"}</span>
                  <InfoIcon id={"Tooltip-markedAttendance-NA"}></InfoIcon>
                </Tooltip>
              </Space>
            ) : dataMarkedLecture ? (
              <Popover
                placement="leftTop"
                content={() => (
                  <>
                    {dataMarkedLecture.map((ele: any, index: number) => (
                      <div
                        key={index}
                        className="markedLectureCountStyle d-flex flex-column justify-content-between mb-2"
                      >
                        <div className="d-flex flex-row w-100">
                          <Typography variant="h6" color="black">
                            {ele.label} &nbsp;
                          </Typography>
                          <Typography variant="h6" color="black">
                            {ele.value}
                          </Typography>
                        </div>
                      </div>
                    ))}
                    {/* <div className="d-flex flex-row w-100 text-muted">
                      Data excludes the ALC classes
                    </div> */}
                  </>
                )}
                title={""}
              >
                <div
                  className={
                    item?.markedAttendancePercent ||
                    item?.markedAttendancePercent == 0
                      ? "tableIdStyle"
                      : percentage || percentage == 0
                      ? "tableIdStyle"
                      : ""
                  }
                >
                  {item?.markedAttendancePercent &&
                  item?.markedAttendancePercent == 0
                    ? "0%"
                    : item?.markedAttendancePercent &&
                      item?.markedAttendancePercent > 0
                    ? parseFloat(item?.markedAttendancePercent.toFixed(0)) + "%"
                    : percentage
                    ? percentage + "%"
                    : percentage == 0
                    ? "0%"
                    : "-"}
                </div>
              </Popover>
            ) : (
              "-"
            )}
          </div>
        );
      },
    },
    {
      title: "Today’s Unmarked Attendance",
      dataIndex: "todayUnmarkedAttendanceCount",
      access: ["Faculty"],
      sorter: true,
      render: (_: any, record: any) => {
        return (
          <div
            className={
              record?.todayUnmarkedAttendanceCount ||
              record?.todayUnmarkedAttendanceCount == 0
                ? "tableIdStyle"
                : ""
            }
          >
            <span onClick={() => handleTodayUnmarkedAttendance(record)}>
              {record?.todayUnmarkedAttendanceCount}
            </span>
          </div>
        );
      },
    },
    {
      title: "Overall Ratings",
      dataIndex: "overallRatingAvg",
      access: ["Branch", "Region", "State", "Faculty"],
      sorter: true,
      render: (_: any, item: any) => {
        return (
          <span
            className="tableIdStyle"
            onClick={() => handleOverAllratingmodal(item)}
          >
            {item.overallRatingAvg === 0 ? "-" : item.overallRatingAvg}
          </span>
        );
      },
    },
    {
      title: "No. of feedbacks",
      dataIndex: "numberOfFeedbacks",
      access: ["Branch", "Region", "State", "Faculty"],
      sorter: true,
      render: (_: any, record: any) => {
        return <span>{record?.numberOfFeedbacks}</span>;
      },
    },
    {
      title: "Feedback Received",
      dataIndex: "weightedNumberOfFeedback",
      access: ["Branch", "Region", "State", "Faculty"],
      sorter: true,
      render: (_: any, record: any) => {
        return <span>{record?.weightedNumberOfFeedback}</span>;
      },
    },
    {
      title: "Students interaction",
      dataIndex: "followUpCount",
      access: ["Branch", "Region", "State", "Faculty"],
      render: (_: any, item: any) => {
        const dataMarkedLecture = returnFollowUpCount(
          item.followUpCount,
          item.ptmCount
        );
        return (
          <div>
            {dataMarkedLecture ? (
              <Popover
                placement="leftTop"
                content={() => (
                  <>
                    {dataMarkedLecture.map((ele: any, index: number) => (
                      <div
                        key={index}
                        className="markedLectureCountStyle d-flex flex-column justify-content-between mb-2"
                      >
                        <div className="d-flex flex-row w-100">
                          <Typography variant="h6" color="black">
                            {ele.label} &nbsp;
                          </Typography>
                          <Typography variant="h6" color="black">
                            {ele.value}
                          </Typography>
                        </div>
                      </div>
                    ))}
                  </>
                )}
                title={""}
              >
                <div
                  className={
                    item.followUpCount + item.ptmCount > 0 ? "tableIdStyle" : ""
                  }
                >
                  {item.followUpCount + item.ptmCount > 0
                    ? item.followUpCount + item.ptmCount
                    : "-"}
                </div>
              </Popover>
            ) : (
              "-"
            )}
          </div>
        );
      },
    },
  ];
  const handleTableChange = (paginations: any, filters: any, sorter: any) => {
    const sortField = sorter.field || pagination.sortField;
    let sortOrder = pagination.sortOrder;
    if (sorter.order !== undefined) {
      sortOrder = sorter.order === "descend" ? "DESC" : "ASC";
    }
    setPagination({
      ...paginations,
      sortField,
      sortOrder: sortOrder,
    });
  };
  const mapData = (aggregatedData: any, updatedDataForModal: any): [] => {
    const updatedFeedbackData = {
      behaviourInClassResponseAvg: aggregatedData.behaviourAvg,
      teachingPaceResponseAvg: aggregatedData.teachingPaceAvg,
      weightedNumberOfFeedback: aggregatedData.numberOfFeedbacks,
      overallRatingResponseAvg: aggregatedData.overallRatingAvg,
      doubtResolutionResponseAvg: aggregatedData.doubtResolutionAvg,
    };
    updatedDataForModal.push(updatedFeedbackData);
    return updatedDataForModal;
  };
  console.log(data, "item1233");
  return (
    <>
      {isLectureViewModal && selectedRowItem && (
        <FeedbackViewModal
          setYearMonthForFeedback={null}
          mode="myBatchLectureABC"
          selectedlecture={null}
          isLectureViewModal={isLectureViewModal}
          setIsLectureViewModal={setIsLectureViewModal}
          facultyFeedbackData={mapData(selectedRowItem, [])}
        ></FeedbackViewModal>
      )}
      <Table
        scroll={{ x: "max-content" }}
        bordered
        size="small"
        columns={columns.filter((ele: any) => ele.access.includes(mode))}
        dataSource={data}
        pagination={pagination}
        onChange={handleTableChange}
      />
    </>
  );
};

export default FacultiesRegionsTable;
